import * as React from 'react';

interface Props {
	visible: boolean;
}

interface State {
}

export default class ExplanationComponent extends React.Component<Props, State> {

	render () {
		return <p style={{fontSize: '21px', lineHeight: 1.5, margin: '1em 0', color: 'darkorange', visibility: this.props.visible ? 'visible' : 'hidden'}}>{this.props.children}</p>;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/exercises/ExplanationComponent.tsx